import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent implements OnInit {

  estimacionFin: string = '';

  constructor(
    private translateService: TranslateService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    let fechaEstimada: Date = undefined;
    try {
      fechaEstimada = environment.ESTIMATED_MAINTENANCE_FINISH_DATE ? new Date(environment.ESTIMATED_MAINTENANCE_FINISH_DATE) : undefined;
    } catch (ex) {
      // environment.ESTIMATED_MAINTENANCE_FINISH_DATE probablemente no tiene un formato correcto de instante,
    }
    let textEstimacion: string;
    let textSinEstimacion: string;
    this.translateService.get(['mantenimiento']).subscribe(result => {
      textEstimacion = result['mantenimiento']['estimacionFin'];
      textSinEstimacion = result['mantenimiento']['sinEstimacionFin'];
      this.estimacionFin = fechaEstimada ? textEstimacion.replace('{FECHA_ESTIMADA}',
        this.datePipe.transform(fechaEstimada, 'shortTime')) : textSinEstimacion;
      console.log(this.estimacionFin);
    });
  }

}
